"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaneDataObjectBuilder = void 0;
var realmforge_common_1 = require("realmforge-common");
var AbstractDataObjectBuilder_1 = require("./AbstractDataObjectBuilder");
var realms_three_1 = __importDefault(require("realms-three"));
var utils_1 = require("../utils");
var realms_three_utils_1 = require("realms-three-utils");
var PlaneDataObjectBuilder = /** @class */ (function (_super) {
    __extends(PlaneDataObjectBuilder, _super);
    function PlaneDataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a data object
     */
    PlaneDataObjectBuilder.prototype.createDataObject = function (params) {
        var _a, _b;
        return __assign(__assign({}, this.utils.createBaseDataObject(params)), { type: realmforge_common_1.DataObjectType.Plane, material: (_a = params.material) !== null && _a !== void 0 ? _a : null, geometry: params.geometry, shapeProperties: params.shapeProperties, heightMapData: (_b = params.heightMapData) !== null && _b !== void 0 ? _b : [] });
    };
    PlaneDataObjectBuilder.prototype.buildThreeObject = function (dataObject, _, methods) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, widthUnits, heightUnits, unitSize;
            return __generator(this, function (_b) {
                _a = dataObject.geometry, widthUnits = _a.widthUnits, heightUnits = _a.heightUnits, unitSize = _a.unitSize;
                return [2 /*return*/, this.updateThreeObject(dataObject, new realms_three_1.default.Mesh(new realms_three_1.default.PlaneGeometry(widthUnits * unitSize, heightUnits * unitSize, widthUnits, heightUnits), new realms_three_1.default.MeshPhongMaterial({
                        color: (0, utils_1.hexStringToNumber)(realmforge_common_1.DEFAULT_SHAPE_COLOR),
                    })), methods)];
            });
        });
    };
    PlaneDataObjectBuilder.prototype.updateThreeObject = function (params, threeObject, methods) {
        return __awaiter(this, void 0, void 0, function () {
            var oldPlaneGeometry, _a, widthUnits, unitSize, heightUnits, newGeometry;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        threeObject = this.utils.setThreeProperties(params, threeObject);
                        return [4 /*yield*/, this.utils.setThreeMaterial(params, threeObject, methods)];
                    case 1:
                        threeObject = _c.sent();
                        if (threeObject instanceof realms_three_1.default.Mesh && "side" in threeObject.material) {
                            threeObject.material.side = realms_three_1.default.DoubleSide;
                        }
                        threeObject = this.utils.setThreeShapeProperties(params, threeObject);
                        if ((params.geometry || params.heightMapData) &&
                            threeObject instanceof realms_three_1.default.Mesh) {
                            oldPlaneGeometry = threeObject.geometry;
                            _a = (_b = params.geometry) !== null && _b !== void 0 ? _b : {
                                widthUnits: oldPlaneGeometry.parameters.widthSegments,
                                heightUnits: oldPlaneGeometry.parameters.heightSegments,
                                unitSize: oldPlaneGeometry.parameters.width /
                                    oldPlaneGeometry.parameters.widthSegments,
                            }, widthUnits = _a.widthUnits, unitSize = _a.unitSize, heightUnits = _a.heightUnits;
                            threeObject.geometry.dispose();
                            newGeometry = new realms_three_1.default.PlaneGeometry(widthUnits * unitSize, heightUnits * unitSize, widthUnits, heightUnits);
                            if (params.heightMapData && params.heightMapData.length > 0) {
                                newGeometry = (0, realms_three_utils_1.applyHeightMapToPlaneGeometry)(newGeometry, {
                                    data: params.heightMapData,
                                    width: widthUnits,
                                    height: heightUnits,
                                });
                            }
                            threeObject.geometry = newGeometry;
                        }
                        return [2 /*return*/, threeObject];
                }
            });
        });
    };
    /**
     * Default params
     */
    PlaneDataObjectBuilder.prototype.getDefaultCreateParams = function (_a) {
        var blueprintId = _a.blueprintId;
        return {
            type: realmforge_common_1.DataObjectType.Plane,
            geometry: {
                type: realmforge_common_1.DataObjectGeometryType.Plane,
                widthUnits: 100,
                heightUnits: 100,
                unitSize: 1,
            },
            shapeProperties: {
                physicsType: realmforge_common_1.PhysicsType.Body,
            },
            transformation: {
                rotation: {
                    x: (-1 * Math.PI) / 2,
                    y: 0,
                    z: 0,
                },
            },
            blueprintId: blueprintId,
        };
    };
    PlaneDataObjectBuilder.prototype.updateDataObject = function (oldDataObject, params) {
        var newDataObject = __assign(__assign({}, oldDataObject), this.utils.updateBaseDataObject(oldDataObject, params));
        if (params.material !== undefined) {
            // Update new
            newDataObject.material = params.material;
        }
        if (params.geometry !== undefined) {
            // Update new
            newDataObject.geometry = params.geometry;
        }
        if (params.shapeProperties !== undefined) {
            // Update new
            newDataObject.shapeProperties = params.shapeProperties;
        }
        if (params.heightMapData !== undefined) {
            newDataObject.heightMapData = params.heightMapData;
        }
        return newDataObject;
    };
    return PlaneDataObjectBuilder;
}(AbstractDataObjectBuilder_1.AbstractDataObjectBuilder));
exports.PlaneDataObjectBuilder = PlaneDataObjectBuilder;
